export function lockSwipers(instances, lock) {
  instances.forEach(swiper => {
    if (lock) {
      swiper.mousewheel.disable();
    } else {
      swiper.mousewheel.enable();
    }
  });
}
